<h2 mat-dialog-title>Lista de env&iacute;o</h2>
<div mat-dialog-content>
  <br>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Ingrese un nombre</mat-label>
    <input matInput [(ngModel)]="name" />
  </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Buscar participantes</mat-label>
      <input matInput [(ngModel)]="searchText" (keyup.enter)="search()" />
      @if((searchText.trim().length || 0) > 0){
      <button matIconButton matSuffix aria-label="Limpiar"
        (click)="searchText = ''; search()"><mat-icon>close_small</mat-icon></button>
      }
      <button matIconButton matSuffix aria-label="Buscar"
        (click)="search()"><mat-icon>search</mat-icon></button>

    </mat-form-field>

  <div class="lists">
    <div class="list-box left">
        <mat-action-list class="scroll-list">
          @for (item of available; track $index) {
          <button mat-list-item  (dblclick)="add(item)" (click)="selectAvailable(item)"
            [class.active]="selectedAvailableItem?.id === item.id" title="{{ getDisplayName(item) }}">
            <span matListItemTitle>{{ getDisplayName(item) }}</span>
            <span matListItemLine>{{ (item.departamento ? (item.departamento + ' - ') : '') + (item.cargo ||
                item.dependencia || item.titulo || '') }}</span>
          </button>
          }
        </mat-action-list>
    </div>

    <div class="center-controls" role="group" aria-label="Controles de movimiento">
      <div class="ctrl-group">
        <button mat-icon-button aria-label="Agregar uno" matTooltip="Agregar seleccionado" (click)="moveOneRight()"
          [disabled]="!selectedAvailableItem">
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-icon-button aria-label="Agregar todos" matTooltip="Agregar todos" (click)="addAll()">
          <mat-icon>keyboard_double_arrow_right</mat-icon>
        </button>
      </div>
      <div class="ctrl-sep" aria-hidden="true"></div>
      <div class="ctrl-group">
        <button mat-icon-button c aria-label="Quitar uno" matTooltip="Quitar seleccionado" (click)="moveOneLeft()"
          [disabled]="!selectedSelectedItem">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button mat-icon-button aria-label="Quitar todos" matTooltip="Quitar todos" (click)="removeAll()">
          <mat-icon>keyboard_double_arrow_left</mat-icon>
        </button>
      </div>
    </div>

    <div class="list-box right">
        <mat-action-list class="scroll-list">
          @for (item of selected; track $index) {
          <button mat-list-item (dblclick)="remove(item)" (click)="selectSelected(item)"
            [class.active]="selectedSelectedItem?.id === item.id" title="{{ getDisplayName(item) }}">
            <span matListItemTitle>{{ getDisplayName(item) }}</span>
            <span matListItemLine>{{ (item.departamento ? (item.departamento + ' - ') : '') + (item.cargo ||
                item.dependencia || item.titulo || '') }}</span>
          </button>
          }
        </mat-action-list>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="accept()">Aceptar</button>
</div>